const otpFlow = [
  {
    property: 'partner.enableOTP',
    value: true
  }
]

module.exports = {
  otpFlow
}



// WEBPACK FOOTER //
// ./src/partners/flow/conditions.js